import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import MainLayout from "./MainLayout";

import {
  Users,
  CalendarOff,
  Clock3,
  Star,
  LayoutDashboard,
  UserCheck,
  TrendingUp,
  TrendingDown,
  Briefcase,
  PieChart,
  CalendarCheck,
  Wifi,
  Wallet,
  CalendarX,
  FileText,
  AlarmClock,
  Timer,
  CreditCard,
  ClipboardList,
  MapPin,
} from "lucide-react";
// import "../styles/Reports.css"; 
import "../styles/reports.css";

const reportSections = [
  {
    title: "Employee Information",
    icon: <Users size={20} />,
    color: "#6366f1",
    reports: [
      { name: "Dashboard", icon: <LayoutDashboard size={15} />, path: null },
      { name: "Headcount", icon: <Users size={15} />, path: null },
      { name: "Employee Addition Trend", icon: <TrendingUp size={15} />, path: null },
      { name: "Employee Attrition Trend", icon: <TrendingDown size={15} />, path: null },
      { name: "Career History", icon: <Briefcase size={15} />, path: null },
      { name: "Distribution", icon: <PieChart size={15} />, path: null },
    ],
  },
  {

    title: "Leave Tracker",
    icon: <CalendarOff size={20} />,
    color: "#0ea5e9",
    reports: [
      { name: "Daily Leave Status", icon: <CalendarCheck size={15} />, path: null },
      { name: "Resource Availability", icon: <Wifi size={15} />, path: null },
      { name: "Employee Leave Balance", icon: <Wallet size={15} />, path: null },
      { name: "Leave Booked And Balance", icon: <CalendarX size={15} />, path: null },
      { name: "Leave Type Wise Summary", icon: <FileText size={15} />, path: null },
      { name: "Leave Encashment Details", icon: <CreditCard size={15} />, path: null },
    ],
  },
  {
    title: "Attendance",
    icon: <Clock3 size={20} />,
    color: "#0ea5e9",

    reports: [
      { name: "Daily Attendance Status", icon: <CalendarCheck size={15} />, path: "/reports/daily-attendance" },
      { name: "Employee Present/Absent Status", icon: <UserCheck size={15} />, path: "/reports/attendance-report" },
      { name: " Monthly Attendance Report ", icon: <UserCheck size={15} />, path: "/reports/admin-attendance-report" },
      { name: "LOP Report", icon: <AlarmClock size={15} />, path: "/reports/lop-report" },
      { name: "Presence Hours Break-Up", icon: <Timer size={15} />, path: null },
      { name: "Attendance Data For Payroll", icon: <CreditCard size={15} />, path: null },
      { name: "Muster Roll", icon: <ClipboardList size={15} />, path: null },
    ],
  },
];

export default function ReportsPage() {
  const [starred, setStarred] = useState({});
  const navigate = useNavigate();

  const toggleStar = (e, key) => {
    e.stopPropagation();
    setStarred((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleReportClick = (report) => {
    if (report.path) navigate(report.path);
  };

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  return (
    <MainLayout sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} title="Reports" subtitle="Manage and view organization reports">
      <div className="reports-page">
        <div className="reports-grid">
          {reportSections.map((section) => (
            <div key={section.title} className="reports-card">
              <div className="reports-card-header">
                <span
                  className="reports-section-icon"
                  style={{ color: section.color }}
                >
                  {section.icon}
                </span>
                <h3
                  className="reports-section-title"
                  style={{ color: section.color }}
                >
                  {section.title}
                </h3>
              </div>

              <ul className="reports-list">
                {section.reports.map((report) => {
                  const key = `${section.title}-${report.name}`;
                  const isStarred = !!starred[key];
                  const isClickable = !!report.path;

                  return (
                    <li
                      key={report.name}
                      className={`reports-item ${isClickable ? "clickable" : ""} ${report.highlight ? "highlight" : ""}`}
                      onClick={() => handleReportClick(report)}
                    >
                      <Star
                        size={15}
                        className="reports-star"
                        style={{
                          fill: isStarred ? "#f59e0b" : "none",
                          stroke: isStarred ? "#f59e0b" : "#9ca3af",
                        }}
                        onClick={(e) => toggleStar(e, key)}
                      />
                      <span className="reports-item-icon">{report.icon}</span>
                      <span className="reports-item-name">
                        {report.name}
                      </span>
                      {report.highlight && (
                        <span className="reports-click-chip">Click </span>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}